module.exports = __webpack_public_path__ + "static/media/adminIcon.3e61d7d3.png";